<template>
    <div>
        <card-header title="Change Photo" icon="fa-camera"/>

        <card-body>
            <card-list>
                <container-list-item padded class="content">
                    <p>Upload a profile photo for this customer. It appears on their Navigator
                        profile and here in Roger. Best framed as a square head-shot &mdash;
                        it is cropped to a 150&times;150 thumbnail.</p>
                </container-list-item>
                <container-list-item v-if="newPhoto.file">
                    <data-row title="File">{{newPhoto.file_name}}</data-row>
                    <data-row title="Type">{{newPhoto.file_mime}}</data-row>
                </container-list-item>
                <container-list-item padded>
                    <file-pond
                        name="file"
                        ref="pond"
                        label-idle="Drop or click to add photo..."
                        :allow-multiple="false"
                        :allowRevert="false"
                        accepted-file-types="image/jpeg, image/png, image/gif"
                        :files="files"
                        @init="handleFilePondInit"
                        @processfile="handleFilePondProcess"
                        :server="{
                                    url: apiUrl,
                                    timeout: 7000,
                                    process: {
                                        url: 'api/users/photo/upload',
                                        method: 'POST',
                                        headers: {
                                            'Authorization': token
                                        },
                                        withCredentials: false
                                    }
                                }"
                    />
                </container-list-item>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <b-button type="is-primary" size="is-small" :disabled="!newPhoto.file" @click="submit"><i class="fas fa-check mr-3"></i>Save Photo</b-button>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from '../../TIER/components/CardHeader';

    import {client as http} from '../../http_client';
    import CardFooter from "../../TIER/components/CardFooter";
    import CardList from "../../TIER/components/CardList";
    import CardBody from "../../TIER/components/CardBody";
    import ContainerListItem from "../../TIER/components/ContainerListItem";

    // Import Vue FilePond
    import vueFilePond from 'vue-filepond';

    // Import FilePond styles
    import 'filepond/dist/filepond.min.css';

    // Import image preview plugin styles
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

    // Import image preview and file type validation plugins
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
    import {mapGetters} from "vuex";
    import DataRow from "@/TIER/components/DataRow";

    // Create component
    const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

    export default {
        props: ['card', 'props'],
        components: {DataRow, FilePond, ContainerListItem, CardBody, CardList, CardFooter, CardHeader},
        data: function() {
            return {
                apiUrl: '/',
                newPhoto: {
                    file: null,
                    file_name: null,
                    file_mime: null
                },
                files: []
            };
        },
        computed: {
            ...mapGetters(['token']),
        },
        methods: {
            submit() {
                this.$emit('loading', true);
                // TEN-129 — persist the uploaded photo onto the customer. Partial
                // update: db_util only writes the columns present in the body.
                http.put('/api/users/' + this.props.userId, {
                    id: this.props.userId,
                    photo_file: this.newPhoto.file,
                    photo_mime: this.newPhoto.file_mime
                }, {force: true}).then(response => {
                    this.$reloadCard('customer', {userId: this.props.userId});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    console.log('An error occurred.');
                    this.$emit('loading', false);
                });
            },
            handleFilePondInit: function() {
            },

            handleFilePondProcess: function(err, response) {
                let file = JSON.parse(response.serverId);

                this.newPhoto.file = file.file_name;
                this.newPhoto.file_name = file.file_original_name;
                this.newPhoto.file_mime = file.file_mime;

                setTimeout(function() {
                    this.$refs.pond.removeFile(file.id);
                }.bind(this), 3000);
            },
        },
        mounted() {
            this.$saveAlert(true, 'Are you done changing this photo? Unsaved changes will be lost.');
        }
    };
</script>

<style>
    .filepond--credits {
        display: none !important;
    }
</style>
